import Base from "@/controllers/base";
export default class BaseRate extends Base {
  static chart(selector, data, title) {
    var canvas, config, ctx, div;
    div = document.getElementById(selector);
    if (div) {
      div.innerHTML = null;
      canvas = document.createElement("canvas");
      div.appendChild(canvas);
      ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      config = {
        type: "scatter",
        data: {
          datasets: data.datasets,
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          hover: {
            mode: "nearest",
            intersect: false,
          },
          scales: {
            x: {
              type: "linear",
              position: "bottom",
            },
            y: {
              labelString: "Rate $",
              ticks: {
                beginAtZero: true,
              },
            },
          },
          plugins: {
            title: {
              display: true,
              text: title,
              position: "right",
            },
            tooltip: {
              mode: "index",
              intersect: false,
              callbacks: {
                title: function (context) {
                  return `Miles: ${context[0].label}`;
                },
                label: function (context) {
                  const {
                    dataIndex,
                    dataset: { label, data },
                  } = context;
                  let details = data[dataIndex];
                  if (details["profit"]) {
                    return (
                      label +
                      ": " +
                      details["y"] +
                      " (Profit: " +
                      details["profit"] +
                      ")"
                    );
                  } else {
                    return label + ": " + details["y"];
                  }
                },
              },
            },
          },
        },
      };
      return new Chart(ctx, config);
    }
  }
}
